/* eslint-disable max-statements */
import React, {useEffect, useState} from 'react';
import {Accordion, Card} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import '../styles/styles.scss';
import {toCapitalize} from '../utils';
import OriginOrdersTable from '../main/originOrdersTable';
import SummaryTable from '../main/summaryTable';

const MenuScreen = (props) => {
  const [accordionValue, setAccordionValue] = useState({});

  const generateAccordion = (originsMenu) => {
    let currentCountry = '';
    let AccordionData = [];

    originsMenu.forEach((origin) => {
      if (currentCountry !== origin.procedencia) {
        currentCountry = origin.procedencia;
        AccordionData = [
          ...AccordionData,
          {
            'key': origin.pedido_no,
            'title': `${toCapitalize(origin.svprdescri)}`,
            'content': {
              'content': (
                <OriginOrdersTable
                  code={origin.procedencia}
                  originsMenu={originsMenu}
                  fetchGetOrderSummary={props.fetchGetOrderSummary}
                />
              ),
            },
          },
        ];
      }
    });
    return AccordionData;
  };

  useEffect(() => {
    props.cleanHeaderValues();
    props.fetchGetOriginsMenu();
  }, []);

  useEffect(() => {
    if (props.originsMenu) {
      setAccordionValue(generateAccordion(props.originsMenu));
    }
  }, [props.originsMenu]);

  return (
    <>
      <Card raised fluid className="container-table margin-menu card-center-custom">
        <div className='container-index-tables'>
          <div className='container-items'>
            <h3>Pedidos por orígen</h3>
            {Object.keys(accordionValue).length === 0 ? <p>No existen pedidos.</p> :
              <Accordion
                styled
                vertical
                className="accordion-container"
                panels={accordionValue}
              />
            }
          </div>
          <div className='container-summary'>
            <h3>Información de pedido</h3>
            <SummaryTable />
          </div>
        </div>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'loading': state.manageOrders.loading,
    'originsMenu': state.manageOrders.originsMenu,
  };
};

const {
  cleanHeaderValues,
  fetchGetOrderSummary,
  fetchGetOriginsMenu,
} = Actions;

export default connect(mapStateToProps, {
  cleanHeaderValues,
  fetchGetOrderSummary,
  fetchGetOriginsMenu,
})(MenuScreen);
